import React from "react";
import PropTypes from "prop-types";
import Button from "../common/Button";
import Modal from 'react-bootstrap/Modal';
import "./formModal.scss";
import modalClose from "../../svg/modal-close.svg";

const FormModal = (props) => {
    const {
        show,
        handleClose,
        children,
        closebutton,
        modalHeading,
        submitButtonTitle,
        onSubmit,
        disabled,
        informationText,
        upperInformationText,
        lowerInformationText,
        customClass
    } = props;
    return (
        <Modal backdrop="static" show={show} onHide={handleClose} className={customClass ? `${customClass} static-modal` : "static-modal"} centered>
            <Modal.Header
                closeButton={closebutton}
                className="justify-content-center"
            >
                <Modal.Title>{modalHeading}</Modal.Title>
                <img src={modalClose} alt="no-img" className="modal-close" onClick={handleClose} />

            </Modal.Header>
            <div className="text-center label" dangerouslySetInnerHTML={{ __html: informationText }}></div>
            <div className="text-center label" dangerouslySetInnerHTML={{ __html: upperInformationText }}></div>
            <div className="text-center label">{lowerInformationText}</div>

            <Modal.Body >{children}</Modal.Body>
            <Modal.Footer className="justify-content-center">
                {submitButtonTitle && (
                    <Button
                        title={submitButtonTitle}
                        disabled={disabled}
                        type="button"
                        handleClick={onSubmit}
                    />
                )}
            </Modal.Footer>
        </Modal>
    );
};
FormModal.propTypes = {
    show: PropTypes.bool,
    closebutton: PropTypes.bool,
    children: PropTypes.node.isRequired,
    handleClose: PropTypes.func,
    modalHeading: PropTypes.string,
    submitButtonTitle: PropTypes.string,
    onSubmit: PropTypes.func,
    disabled: PropTypes.bool,
    informationText: PropTypes.string,
    upperInformationText: PropTypes.string,
    lowerInformationText: PropTypes.string,
    customClass : PropTypes.string
};

FormModal.defaultProps = {
    show: false,
    closebutton: false,
    modalHeading: "",
    submitButtonTitle: "",
    onSubmit: () => null,
    handleClose: () => null,
    disabled: false,
    informationText: "",
    upperInformationText: "",
    lowerInformationText: "",
    customClass : ""
};

export default FormModal;
